import { InvoiceCategoryFilter, InvoiceState } from '@treadinc/horizon-api-spec';

import { spacing } from '~theme/AppTheme';

export const ORDERS_LIST_CONTAINER_VERTICAL_GAP = spacing(1.5);

// Invoice states behind the Approved/Unapproved/In Settlement quick-filter toggles
// (InvoiceStateFilters). With every toggle off the list shows all states with no
// grouped narrowing — that is also the post-clear state applied by
// clearAllFiltersExceptSearch and assumed by its probe.
export const UNAPPROVED_INVOICE_STATES = [
  InvoiceState.PENDING,
  InvoiceState.CUSTOMER_PENDING,
];
export const APPROVED_INVOICE_STATES = [
  InvoiceState.APPROVED,
  InvoiceState.PAID,
  InvoiceState.VOIDED,
  InvoiceState.CUSTOMER_APPROVED,
  InvoiceState.CUSTOMER_PAID,
];
export const ALL_INVOICE_STATES = [
  ...UNAPPROVED_INVOICE_STATES,
  ...APPROVED_INVOICE_STATES,
];

// URL params tracking the quick-filter toggle states.
export const UNAPPROVED_TOGGLE_QS_PARAM = 'unapproved';
export const APPROVED_TOGGLE_QS_PARAM = 'approved';
export const IN_SETTLEMENT_TOGGLE_QS_PARAM = 'in_settlement';
export const INVOICES_QUERY_CONTEXT_PREFIX = 'InvoicesQueryContextProvider';
export const DRIVER_PAY_QUERY_CONTEXT_PREFIX = 'DriverPayQueryContextProvider';

export const payableInvoiceCategories = [
  InvoiceCategoryFilter.INTERNAL_PAYABLES,
  InvoiceCategoryFilter.OWNER_OPERATOR_PAYABLES,
  InvoiceCategoryFilter.PAYABLES,
  InvoiceCategoryFilter.VENDOR_PAYABLES,
];

export const receivableInvoiceCategories = [
  InvoiceCategoryFilter.ACCOUNT_RECEIVABLES,
  InvoiceCategoryFilter.CONNECTION_RECEIVABLES,
  InvoiceCategoryFilter.RECEIVABLES,
];

export enum DriverPayQueryOrdersSort {
  ACCOUNT_NAME = 'account_name',
  COMPANY_LEGAL_NAME = 'company_legal_name',
  CREATED_AT = 'created_at',
  FRIENDLY_ORDER_ID = 'friendly_order_id',
}
